import { render, staticRenderFns } from "./FooterConfig.vue?vue&type=template&id=510fef6a&scoped=true&"
import script from "./FooterConfig.vue?vue&type=script&lang=js&"
export * from "./FooterConfig.vue?vue&type=script&lang=js&"
import style0 from "./FooterConfig.vue?vue&type=style&index=0&id=510fef6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fef6a",
  null
  
)

export default component.exports